














































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  setFilterOptionDateByName,
  toLocalDateFormatted,
  checkValidDateRange,
  toDateIsoString
} from '@/common/utils/date';
import { bus } from '@/services/busService';
import { SearchFilters } from '@/types/search';

@Component({
  name: 'DateSelection',
  components: {}
})
export default class DateSelection extends Vue {
  @Prop({ required: true })
  isCustomSearch!: boolean;

  @Prop({ required: true })
  searchFilters!: SearchFilters;

  @Watch('dateRange')
  updateDateRangeOnChnage() {
    if (this.dateRange && this.dateRange?.length > 1 && new Date(this.dateRange[1]) < new Date(this.dateRange[0])) {
      this.dateRange.shift();
    }
  }

  private endDate: string = toDateIsoString(new Date());
  private startDate: string = toDateIsoString(new Date());
  private selectedFilterOption = '';
  private isMenuOpen = false;
  private isDateMenuOpen = false;

  private filterOptions = {
    startDate: '',
    endDate: ''
  };

  private dateRange: string[] | null = null;

  get dateRangeText(): string {
    if (!this.dateRange) {
      return 'Select date';
    } else {
      return this.dateRange.length > 1
        ? `${toLocalDateFormatted(new Date(this.dateRange[0]), 'DD/MM/YY')} - ${toLocalDateFormatted(
            new Date(this.dateRange[1]),
            'DD/MM/YY'
          )}`
        : toLocalDateFormatted(new Date(this.dateRange[0]), 'DD/MM/YY');
    }
  }

  get isInvalidDateRange(): boolean {
    return !this.dateRange || this.dateRange?.length != 2;
  }

  mounted() {
    this.filterOptions.startDate = this.searchFilters.dateFrom;
    this.filterOptions.endDate = this.searchFilters.dateTo;
    this.selectedFilterOption = this.searchFilters.dateFilterOption;
    bus.$on('resetDate', () => {
      this.selectedFilterOption = 'Today';
      this.setSelectedFilterOption('Today');
    });
  }

  private setSelectedFilterOption(name: string): void {
    this.isMenuOpen = false;
    this.selectedFilterOption = name;
    this.setFilterOptionByName(this.selectedFilterOption);
    this.$emit('updateFilterOption', this.filterOptions.startDate, this.filterOptions.endDate, name);
  }

  private updateDateRange(): void {
    this.setDateRange(this.dateRange);
  }

  private resetDateRange(): void {
    this.setDateRange(null);
  }

  private setDateRange(dateRange: string[] | null): void {
    if (dateRange) {
      this.startDate = toDateIsoString(new Date(dateRange[0]));
      this.endDate = toDateIsoString(new Date(dateRange[1]));
      this.setSelectedFilterOption(
        `${toLocalDateFormatted(new Date(dateRange[0]), 'DD/MM/YY')} - ${toLocalDateFormatted(
          new Date(dateRange[1]),
          'DD/MM/YY'
        )}`
      );
    } else {
      this.dateRange = null;
      this.startDate = toDateIsoString(new Date());
      this.endDate = toDateIsoString(new Date());
    }
  }

  private allowedDates(date: string): boolean {
    if (this.dateRange) {
      return checkValidDateRange(this.dateRange[0], date, 7);
    }
    return true;
  }

  private checkIsSelectedOption(option: string): string {
    if (this.selectedFilterOption === option) {
      return 'v-btn--selected';
    } else if (option.includes('date-range') && this.selectedFilterOption.includes('-')) {
      return 'v-btn--selected';
    }
    return '';
  }

  private setFilterOptionByName(name: string): void {
    const dateOptions = setFilterOptionDateByName(name);
    if (dateOptions.startDateTimeUtc === '' || dateOptions.endDateTimeUtc === '') {
      this.filterOptions.startDate = this.startDate;
      this.filterOptions.endDate = this.endDate;
    } else {
      this.dateRange = null;
      this.filterOptions.startDate = '';
      this.filterOptions.endDate = '';
    }
  }
}
